export default "__VITE_ASSET__Kf2KV1mE__"